import { AssetMemoryRepoZustend } from '../../repositories';

export const makeAssetMemory = <T>() => {
  return new AssetMemoryRepoZustend<T>();
};
